<template>
  <span>
    <i v-if="params.data.has_attachments" class="fas fa-paperclip" />
    <span v-else>N/A</span>
  </span>
</template>

<script>
import Vue from 'vue'
import router from '@router'
import store from '@store'

export default Vue.extend({
  name: 'AttachmentsIndicator',
  router,
  store,
  methods: {
    download(id) {
      this.$store.dispatch('downloadMedia', id, { root: true })
    }
  }
})
</script>
